import { z } from 'zod';

import type { IdCampaignDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import type { createPositionSchema } from './schema';

export enum Step {
  CampaignDetails = 'CampaignDetails',
  ProductSetup = 'ProductSetup',
  Creatives = 'Creatives',
  Strategy = 'Strategy',
}

export type StepMap = {
  [key in Step]?: boolean;
};

export interface PositionCreateFormRouteParams {
  campaignId: IdCampaignDto;
}

export enum PositionFormSearchKey {
  FROM = 'from',
}

export enum PositionFormFromPage {
  SUMMARY = 'summary',
}

export const positionFormSearchParamsSchema = z.object({
  [PositionFormSearchKey.FROM]: z.string().optional(),
});

export type PositionForm = z.input<ReturnType<typeof createPositionSchema>>;
export type PositionSubmitForm = z.output<ReturnType<typeof createPositionSchema>>;
